import Image from 'next/image';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ReactModal from 'react-modal';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';
import classnames from 'classnames';
import ValidationMessage from '../PcModelValidationMessage';
import styles from './styles';
import PcModelModalHelp from '../PcModelModalHelp';

const PcModelAddCartErrorButton = ({
  errors,
  isOpen,
  openModal,
  onClose
}) => {
  const { pcConfigDoc } = usePcConfigurator();
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

  const handleHelpModalOpen = () => {
    onClose();
    setIsHelpModalOpen(true);
  };

  const handleHelpModalClose = () => {
    openModal();
    setIsHelpModalOpen(false);
  };

  if (!errors.length) return null;

  const needHelpTitle = pcConfigDoc?.data?.need_help_title;

  return (
    <>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onClose}
        className="modal-content"
        overlayClassName="modal-overlay"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        preventScroll
        style={{
          overlay: {
            background: 'rgba(255, 255, 255, 0.25)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100,
          },
          content: {
            margin: '10px',
            borderRadius: '2px',
            minWidth: '50vw',
            overflow: 'hidden',
          },
        }}
      >
        <div className="modal-wrapper">
          <div className="modal-header">
            <div className="modal-header-title">
              Looks like there&apos;s a problem
            </div>

            <div className="modal-header-icon" onClick={onClose} />
          </div>

          <div className="modal-body">
            <div className="body-message">
              Resolve the following issues before checking out:
            </div>
            <div className="errors">
              {errors.map((error, index) => (
                <div className="error" key={error}>
                  <div className="icon">
                    <Image draggable={false}
                      src="/icons/icon-exclamation.svg"
                      alt="Error"
                      width={16}
                      height={16}
                    />
                  </div>

                  <ValidationMessage
                    error={error}
                    prevError={index !== 0 ? errors[index - 1] : {}}
                    closeModal={onClose}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="modal-footer">
            <div className="need-help" onClick={handleHelpModalOpen}>
              {needHelpTitle}
            </div>
          </div>
        </div>
      </ReactModal>

      <PcModelModalHelp
        title={needHelpTitle}
        isOpen={isHelpModalOpen}
        onClose={handleHelpModalClose}
        pcConfigDoc={pcConfigDoc}
      />
      <style jsx>{styles}</style>
    </>
  );
};

PcModelAddCartErrorButton.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
  variant: PropTypes.oneOf(['toast', 'icon']),
};

PcModelAddCartErrorButton.defaultProps = {
  variant: 'toast',
};

export default PcModelAddCartErrorButton;
